@if (isLoading()) {
  <div class="d-flex justify-content-center align-items-center flex-fill">
    <app-loading></app-loading>
  </div>
} @else if (error()) {
  <div class="d-flex justify-content-center align-items-center flex-fill">
    <app-no-results imageUrl="/assets/images/no-results/deal-not-found.svg" title="Deal not found">
      It may have been removed by you <br>
      or another team member.
    </app-no-results>
  </div>
} @else {
  <div class="d-flex flex-column gap-4 flex-fill">
    <ul ngbNav [activeId]="route.fragment | async" class="rmv-tabs">
      <li class="rmv-tabs__item" ngbNavItem="details" routerLinkActive="--active">
        <a class="rmv-tabs__link" ngbNavLink [routerLink]="['details']">Details</a>
      </li>
      <li class="rmv-tabs__item" ngbNavItem="details" routerLinkActive="--active">
        <a class="rmv-tabs__link" ngbNavLink [routerLink]="['tasks']">Tasks</a>
      </li>
    </ul>
    <div class="pb-4 flex-fill">
      <router-outlet></router-outlet>
    </div>
  </div>
}
